interface LocationLike {
  id: string;
  is_active?: boolean;
  is_main?: boolean;
}

/**
 * Default location selection for a NEW boat: every active location checked, with
 * the is_main location primary (fallback: first active). Resume paths keep the
 * boat's own saved locations and never call this.
 */
export function buildAllActiveLocationDefaults(locations: LocationLike[]): {
  location_ids: string[];
  primary_location_id: string;
} {
  const active = locations.filter((l) => l.is_active !== false);
  const ids = active.map((l) => l.id);
  const primary = active.find((l) => l.is_main)?.id ?? active[0]?.id ?? '';
  return { location_ids: ids, primary_location_id: primary };
}
